import { ArrowRightAlt, Warning } from '@material-ui/icons';
import clsx from 'clsx';
import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { Button, Container, makeStyles, Paper, Theme, Typography } from '../';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    height: theme.spacing(68),
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: theme.spacing(4),
    '& > *': {
      marginBottom: theme.spacing(4),
    },
  },
  warning: {
    width: theme.spacing(14),
    height: theme.spacing(14),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  symbol: {
    width: theme.spacing(5),
    height: theme.spacing(5),
  },
  arrow: {
    transform: 'rotate(180deg)',
  },
}));

export type NotFoundProps = {
  className?: string;
  returnUrl: string;
};

export const NotFound = ({ className, returnUrl }: NotFoundProps): ReactElement | null => {
  const classes = useStyles();

  return (
    <Container data-testid="not-found-page" className={clsx(classes.root, className, 'fluid')}>
      <Paper variant="outlined" className={classes.paper}>
        <Paper elevation={0} className={classes.warning}>
          <Warning className={classes.symbol} />
        </Paper>
        <Typography variant="h4">Page not found...</Typography>
        <Typography variant="h6">The page is missing or the assembled link is incorrect.</Typography>
        <Button color="primary" component={Link} to={returnUrl} data-testid="404-go-back-button">
          <ArrowRightAlt className={classes.arrow} />
          Go Back
        </Button>
      </Paper>
    </Container>
  );
};
